import {
  FETCH_DETAIL_REPORT_REQUEST,
  FETCH_DETAIL_REPORT_SUCCESS,
  FETCH_DETAIL_REPORT_FAILURE,
} from "../../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status: false,
};

const detailReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DETAIL_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_DETAIL_REPORT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: action.payload.status,
        isLoading: false,
      };
    case FETCH_DETAIL_REPORT_FAILURE:
      return {
        ...state,
        message: action.payload.message,
        status: action.payload.status,
        isLoading: false,
      };

    default:
      return state;
  }
};
export default detailReportReducer;
